export default __webpack_public_path__ + "static/media/miguel-lopes-24.98cb1507.jpg";